<template lang="pug">
  .product-item
    v-card(flat @click="clickEdit")
      //- v-layout.pa-0
        v-img.ma-2(:src="product.image ? product.image.file : require('@/assets/image_placeholder.png')" max-width="110px" width="110px" height="110px")
          v-layout.fill-height
            .count-list-layout(v-if="product.inventory_enabled")
              v-chip.white--text(x-small color="black") {{ getProductCount() }}
        v-col.mr-2.py-2.px-0
          div.product-list-title.pr-2(v-text="product.name")
          show-more-text.product-list-description.mt-2.pr-2(:text="product.description" max=90 style="line-height: 1.2em; min-height:48px;")
          v-row(align="end")
            v-col.pb-2.pt-0
              div.product-list-title {{ product.price | displayPrice }}
            v-col.py-0.pl-0(cols="5" align="end")
              v-btn(icon @click="clickDelete" v-if="member.role === 'Admin'")
                v-icon(color="#6E6E6E") mdi-delete-outline
              v-btn.ml-2(icon @click="clickEdit" v-if="member.role === 'Admin'")
                v-icon(color="primary") mdi-square-edit-outline
                
      v-row(no-gutters)
        v-col.py-1.shrink
          v-img.ma-2(:src="product.image ? product.image.file : require('@/assets/image_placeholder.png')" width="71px" aspect-ratio="1")
            template(v-slot:placeholder)
              v-row(class="fill-height ma-0" align="center" justify="center")
                v-progress-circular(indeterminate color="grey")
            div.d-flex.justify-center.align-end(style="height: 100%" v-if="product.inventory_enabled")
              v-chip.white--text.mb-2(x-small color="primary500") {{ getProductCount() }}
        v-col.py-3.pr-2
          div.p1.basic800--text.mb-1 {{ product.name }}
          div.c1.basic600--text.product-description.mb-1(v-html="product.description")
          div.c2.basic600--text {{ product.price | displayPrice }}
        v-col.shrink.py-3(@click.stop)
          div.d-flex.justify-end(v-if="member.role === 'Admin'")
            v-menu(left :offset-x='true')
              template(v-slot:activator="{ on, attrs }")
                v-btn.mr-2(icon v-on="on")
                  v-icon(color="basic700") mdi-dots-vertical
              v-list(dense)
                v-list-item(@click="clickEdit")
                  v-list-item-title.s2.basic800--text {{ $t('edit') }}
                v-list-item(@click="clickDelete")
                  v-list-item-title.s2.basic800--text {{ $t('delete_product') }}

    .modals
      add-new-add-on(v-if="showAddProductDialog" :open.sync="showAddProductDialog" :productId="productId" :product.sync="product" :setweight="setweight" :setdimension="setdimension")
      y-dialog(v-if="openDeleteDialog" v-model='openDeleteDialog', max-width='320')
        v-card
          v-card-title.h6.basic800--text.px-4 {{ $t('delete_product') }}
          v-card-text.p2.primary500--text.px-4
            div {{ $t('delete_product_confirmation') }}
          v-card-actions
            v-spacer
            v-btn(color='white', text @click='openDeleteDialog = false')
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color='danger500' depressed height=32 @click='startDelete' :loading="isLoading" dark)
              .button-AA-small.basic100--text {{ $t('delete') }}

</template>

<script>
import { mapActions,mapState, mapGetters } from 'vuex'
import AddNewAddOn from '@/components/dialogs/AddNewAddOn.vue'
import ShowMoreText from '@/components/ShowMoreText.vue'

export default {
  name: 'AddOnProductItem',
  props: ['productId', 'product', 'type', 'setweight', 'setdimension'],
  components: { AddNewAddOn, ShowMoreText },
  data: () => ({
    showAddProductDialog: false,
    openDeleteDialog: false,
    isLoading: false,
  }),
  computed: {
    ...mapState('user', ['member']),
    ...mapGetters({
      company: 'getCompany'
    })
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    getProductCount() {
      if (this.product.inventory_qty > 99) {
        return '99+'
      }
      return this.product.inventory_qty.toString()
    },
    clickEdit () {
      this.showAddProductDialog = true
    },
    clickDelete () {
      this.openDeleteDialog = true
    },
    startDelete() {
      this.isLoading = true
      this.axios.patch(`/products/${this.product.id}/`, { deleted: true })
        .then(() => {
          this.$emit('deleted', this.product)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.product-description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical; 
  overflow: hidden;
}
</style>
